import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-skeleton-template',
  templateUrl: './skeleton-template.component.html',
  styleUrls: ['./skeleton-template.component.scss']
})
export class SkeletonTemplateComponent implements OnInit {

  // Replace for interface ISkeleton[]
  @Input() template: any[] = [];
  constructor() { }

  ngOnInit(): void {
  }

}
